import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/spend/$documentId')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ context, params, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_money_document.view'))
      throw redirect({ to: '/accounting/expenses', search })
    throw redirect({
      to: '/accounting/expenses/$documentId',
      params: { documentId: params.documentId },
      search,
    })
  },
  component: () => null,
})
